module.exports = __webpack_public_path__ + "static/media/mintdropz_logo.de26b25d.png";